import React from 'react';
import BusinessPlanHeaderHelper from '../headers/BusinessPlanHeaderHelper';

const BusinessPlanMobileHeader = () => (
  <div className="business-map-header">
    <div className="business-map-info-section mobile">
      <BusinessPlanHeaderHelper />
    </div>
  </div>
);

export default BusinessPlanMobileHeader;



// WEBPACK FOOTER //
// ./src-react/UsaMap/mobile-headers/BusinessPlanMobileHeader.jsx